import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../../DataTable/index";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {
  Alert,
  Box,
  Button,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import moment from "moment";
import MainModal from "../../MainModal";
import { apiPut } from "../../../utils/apiRequests";
import { getAllPotyTournaments } from "../../../redux/actions/tournament-action";
import { useDispatch } from "react-redux";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { useNavigate } from "react-router-dom";

export default function MyComponent(props) {
  const dispatch = useDispatch();

  const courseData = useSelector((state) => state?.coursesReducer?.data);
  const sponsorData = useSelector(
    (state) => state?.getSponsorReducer?.data?.data
  );

  const leagueListData = useSelector(
    (state) => state?.listLeagueReducer?.data?.leagues
  );
  const userRole = useSelector((state) => state.userDetailsReducer?.role);

  const [filterText, setFilterText] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [tournamentId, setTournamentId] = useState("");
  const [message, setMessage] = useState("");
  const [showSnack, setShowSnack] = useState(false);

  const navigate = useNavigate();

  const handleConfirmParticipation = (status) => {
    const obj = { status };
    setMessage("");

    apiPut(
      `${ApiEndpoints.user.base}${ApiEndpoints.user.tournamentParticipation}/${tournamentId}`,
      obj,
      (res) => {
        if (res.error == true) return;
        if (res.error == false) {
          setMessage(res.message);
          setShowSnack(true);
          setTournamentId("");
          setOpenConfirmationModal(false);
          setTimeout(() => {
            dispatch(getAllPotyTournaments());
          }, 1000);
        }
      },
      (err) => console.log("err", err)
    );
  };

  const CustomCellComponent = ({ row }) => {
    const { _id, player_status } = row;
    const color =
      player_status == "Pending"
        ? "#C4C4C4"
        : player_status == "Playing"
        ? "#06623B"
        : player_status == "Skipped"
        ? "#FF0000"
        : player_status == "Played"
        ? "#000000"
        : "#FFC300";

    return (
      <Box
        onClick={() => {
          if (row.tournament_status == "registration open") {
            setTournamentId(_id);
            setOpenConfirmationModal(true);
          }
        }}
        sx={{
          backgroundColor: color,
          width: "8em",
          height: "2.4em",
          borderRadius: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor:
            row.tournament_status == "registration open" ? "pointer" : "auto",
        }}
      >
        <Typography variant={"body3"} sx={{ fontWeight: 700, color: "#fff" }}>
          {player_status}
        </Typography>
      </Box>
    );
  };

  const columns =
    userRole === "admin" || userRole === "super"
      ? [
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Name
              </Typography>
            ),
            selector: (row) => row.name,
            sortable: true,
          },
          {
            name: (
              <Typography
                fontSize="13px"
                variant="subtitle2"
                sx={{ fontWeight: 700 }}
              >
                Season
              </Typography>
            ),
            selector: (row) => row.league_name,
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Course
              </Typography>
            ),
            selector: (row) => row.course_name,
            sortable: true,
          },
          {
            name: (
              <Typography
                fontSize="13px"
                variant="subtitle2"
                sx={{ fontWeight: 700 }}
              >
                Sponsor
              </Typography>
            ),
            selector: (row) => row.sponsor_name,
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Date
              </Typography>
            ),
            selector: (row) =>
              moment(row?.tournament_date).format("DD/MM/YYYY"),
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Status
              </Typography>
            ),
            selector: (row) => row.tournament_status,
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Participation
              </Typography>
            ),
            selector: (row) => row.player_status,
            sortable: true,
            cell: (row) => <CustomCellComponent row={row} />,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Action
              </Typography>
            ),
            sortable: true,
            cell: (row) => (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  size="medium"
                  onClick={(e) => {
                    var selectedLeague = leagueListData?.filter(
                      (sp) => sp.name === row?.league_name
                    );
                    // console.log('selectedLeague', selectedLeague)
                    props.setSelectedLeagueId(selectedLeague[0]._id);

                    var selectedCourse = courseData?.filter(
                      (sp) => sp.name === row?.course_name
                    );

                    var selectedSponsor = sponsorData?.filter((sp) => {
                      return row?.sponsor_name === sp.name;
                    });

                    props.openModal();
                    props.setMode(true);
                    props.setSelectedId(row._id);
                    props.setAddTournament({
                      ...props.addTournament,
                      name: row?.name,
                      course_id: selectedCourse[0]?._id,
                      sponsor_id: selectedSponsor[0]?._id,
                      course_name: row?.course_name,
                      sponsor_name: selectedSponsor[0]?.name,
                      league_id: selectedLeague[0]?._id,
                      reg_start_date: moment(row?.reg_start_date).format("L"),
                      reg_end_date: moment(row?.reg_end_date).format("L"),
                      tournament_date: moment(row?.tournament_date).format("L"),
                      points_multiplier: row?.points_multiplier,
                    });
                  }}
                >
                  <EditRoundedIcon />
                </IconButton>
                <IconButton
                  color="primary"
                  size="medium"
                  onClick={() => {
                    // props.openDeleteModal();
                    props.setDeleteOpen(true);
                    props.setSelectedId(row?._id);
                    props.setSelectedName(row?.name);
                  }}
                >
                  <DeleteRoundedIcon fontSize="medium" />
                </IconButton>
              </>
            ),
          },
        ]
      : [
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Name
              </Typography>
            ),
            selector: (row) => row.name,
            sortable: true,
          },
          {
            name: (
              <Typography
                fontSize="13px"
                variant="subtitle2"
                sx={{ fontWeight: 700 }}
              >
                Season
              </Typography>
            ),
            selector: (row) => row.league_name,
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Course
              </Typography>
            ),
            selector: (row) => row.course_name,
            sortable: true,
          },
          {
            name: (
              <Typography
                fontSize="13px"
                variant="subtitle2"
                sx={{ fontWeight: 700 }}
              >
                Sponsor
              </Typography>
            ),
            selector: (row) => row.sponsor_name,
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Date
              </Typography>
            ),
            selector: (row) => moment(row?.tournament_date).format("L"),
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                State
              </Typography>
            ),
            selector: (row) => row.tournament_status,
            sortable: true,
          },
          {
            name: (
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Participation
              </Typography>
            ),
            selector: (row) => row.player_status,
            sortable: true,
            cell: (row) => <CustomCellComponent row={row} />,
          },
        ];

  const data = [
    {
      id: 1,
      rank: "01",
      playerName: "Danish Feroz",
      points: "653,46",
      tournamentsPlayed: "8",
      fir: "42,86",
      gir: "51,85",
      ppr: "28,00",
      participation: "playing",
    },
    {
      id: 1,
      rank: "01",
      playerName: "Danish Feroz",
      points: "653,46",
      tournamentsPlayed: "8",
      fir: "42,86",
      gir: "51,85",
      ppr: "28,00",
    },
    {
      id: 1,
      rank: "01",
      playerName: "Danish Feroz",
      points: "653,46",
      tournamentsPlayed: "8",
      fir: "42,86",
      gir: "51,85",
      ppr: "28,00",
    },
    {
      id: 1,
      rank: "01",
      playerName: "Danish Feroz",
      points: "653,46",
      tournamentsPlayed: "8",
      fir: "42,86",
      gir: "51,85",
      ppr: "28,00",
    },
  ];

  const conditionalRowStyles = {
    headRow: {
      style: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "rgba(0,0,0,0.6)",
        borderRadius: "5px",
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        "&:hover": {
          cursor: "pointer !important",
        },
      },
    },
  };

  return (
    <>
      <DataTable
        columns={columns}
        data={props.tournamentData}
        selectableRows={false}
        // subHeaderComponent={subHeaderComponentMemo}
        // subHeader
        persistTableHead
        pagination={false}
        customStyles={conditionalRowStyles}
        direction="vertical"
        striped={true}
        onRowClicked={(row, event) => {
          if (userRole === "admin" || userRole === "super") {
            navigate(`/poty-tournaments/${row._id}/tournament-details`);
          } else {
            navigate(`/poty-tournaments/${row._id}/view`);
          }
          // window.location.href = `/poty-tournaments/${row._id}/tournament-details`;
          // console.log("row", row);
        }}
        onSelectedRowsChange={({
          allSelected,
          selectedCount,
          selectedRows,
        }) => {
          props.onChangeSelecteableDelete(selectedRows);
          props.setIsItemSelected(!props.isItemSelected);
        }}
      />

      <Snackbar
        open={showSnack}
        onClose={() => setShowSnack(false)}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert>{message}</Alert>
      </Snackbar>

      <MainModal
        show={openConfirmationModal}
        closeModal={() => setOpenConfirmationModal(false)}
        modalHeadTitle="Confirmation"
        btnLeftTitle="Yes I am in"
        btnRightTitle="Not Interested"
        width="30%"
        btnRightsx={{
          borderRadius: "5px !important",
          backgroundColor: "#F2F2F2",
          color: "#2F4F4F",
          fontWeight: 700,
          minWidth: "180px",
        }}
        btnLeftsx={{
          borderRadius: "5px !important",
          backgroundColor: "#06623B",
          color: "#fff",
          fontWeight: 700,
          minWidth: "180px",
          ":hover": { backgroundColor: "#06623B" },
        }}
        btnCloseModal={() => handleConfirmParticipation("refused")}
        cb={() => handleConfirmParticipation("confirmed")}
        rightVariant="contained"
      >
        <Box sx={{ py: 2 }}>Do you want to participate in this tournament</Box>
      </MainModal>
    </>
  );
}
